import styled from "styled-components";

export const Wrapper = styled("span")({
  color: "red",
});
